// removed by extract-text-webpack-plugin
module.exports = {"usm-container":"OptionExample__usm-container","usmContainer":"OptionExample__usm-container","usm-image":"OptionExample__usm-image","usmImage":"OptionExample__usm-image","usm-label":"OptionExample__usm-label","usmLabel":"OptionExample__usm-label","usm-checkmark":"OptionExample__usm-checkmark","usmCheckmark":"OptionExample__usm-checkmark"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Select/components/OptionExample/OptionExample.css
// module id = 1253
// module chunks = 8